import { render } from "./PositionDirection.vue?vue&type=template&id=6e47f9c2"
import script from "./PositionDirection.vue?vue&type=script&lang=js"
export * from "./PositionDirection.vue?vue&type=script&lang=js"

import "./PositionDirection.vue?vue&type=style&index=0&id=6e47f9c2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__